import {Component, ViewEncapsulation} from '@angular/core';
import { Router, NavigationEnd, UrlSegment } from "@angular/router";
import { IBreadcrumbs, IBreadcrumbsData } from '@signature-it/ngx-generic/interfaces';
import { BreadcrumbsDTO } from '@signature-it/ngx-generic/models';
import { BreadcrumbsService, ShareDataService } from '@signature-it/ngx-generic/services';

declare let _: any;

@Component({
    selector: 'breadcrumbs',
    templateUrl: './breadcrumbs.html',
    styleUrls: [
        './breadcrumbs.scss'
    ],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class BreadcrumbsComponent {

    routerList: IBreadcrumbs[];
    show: boolean = true;
    currentURL:string = '';
    unsubscribeToUrl: boolean = false;
    queryParams: any = {};
	constructor(protected router: Router,
                protected breadcrumbsSvc: BreadcrumbsService,
                protected sharedDataSvc: ShareDataService) {
        this.breadcrumbsSvc.unsubscribeToUrl$.subscribe(res => {
            this.unsubscribeToUrl = res;
        })

		router.events.subscribe(event => {
			if (event instanceof NavigationEnd && this.show && !this.unsubscribeToUrl) {
			    const url = new UrlSegment(event.urlAfterRedirects || event.url, null);
				this._setBreadcrumbs(url);
			}
		});
        this.sharedDataSvc.showBreadcrumbs$.subscribe(show => {
            setTimeout(()=> {
                this.show = show;
                if (!show) return;
                this._setBreadcrumbs(new UrlSegment(this.router.url, null));
            });
        });

        this.breadcrumbsSvc.breadcrumbs$.subscribe(
            (data: IBreadcrumbsData) => {
                setTimeout(()=> {
                    if (data) {
                        if (data.concat) this._setBreadcrumbs(data.list);
                        else this.routerList = data.list;
                    }
                });
            }
        );
        this.queryParams = this.breadcrumbsSvc.queryParamFilter;
        this.currentURL = window.location.protocol + '//' + window.location.host;
	}

	protected _setBreadcrumbs(...params) {
        //product page init breadcrumbs by itself in setBreadcrumbs function
        if (this.router.url.indexOf('product-page') > -1) return;
	    document.getElementsByTagName('breadcrumbs')[0].setAttribute('type', this.breadcrumbsSvc.classAttr);
		if(!params || !params.length || !params[0] || params[0]['path'] === '/') {
            return;
        } else {
            this.routerList = this.breadcrumbsSvc.init();
		    const param0 = params[0];
            if (this.router.url.indexOf('admin') > -1) {
                this._getBCFromAdminURL(param0);
            } else {
                this._getBCFromAPI(param0);
            }
        }
	}

	navigate(link) {
        if (link) this.router.navigate([link], { queryParams: {} });
    }

    protected _getBCFromAPI(params) {
        this.breadcrumbsSvc.getEntityBreadcrumbs({
            'url': decodeURIComponent(params['path'].split('?')[0]),
        }).subscribe(
            res => {
                this.routerList = this.breadcrumbsSvc.init();
                if (res && Object.keys(res).length) {
                    _.each(res, (link, name) => {
                        this.routerList.push(
                            BreadcrumbsDTO.create({
                                name: name,
                                link: link
                            })
                        )
                    });
                    this.checkIsCmsPage();
                } else {
                    this._getBCFromURL(params);
                }
            })
    }

    protected _getBCFromURL(params) {
        let list = params instanceof UrlSegment ? this.breadcrumbsSvc.parse(params) : params;
        if (_.isArray(list)) {
            _.each(list, (dto: IBreadcrumbs) => {
                if (dto instanceof BreadcrumbsDTO) {
                    const prev = this.routerList.map((b) => b.link).join('/');
                    dto.link = `${prev}/${dto.link}`.replace(/^\/\//, '/');
                    this.routerList.push(dto);
                }
            });
        }
        this.checkIsCmsPage();
    }

    protected _getBCFromAdminURL(params) {
        this.routerList.pop();
        let list = params instanceof UrlSegment ? this.breadcrumbsSvc.parse(params) : params;
        if (_.isArray(list)) {
            list.shift();
            _.each(list, (dto: IBreadcrumbs) => {
                if (dto instanceof BreadcrumbsDTO) {
                    const prev = this.routerList.map((b) => b.link).join('/');
                    dto.link = `/admin/${prev}/${dto.link}`.replace(/^\/\//, '/');
                    this.routerList.push(dto);
                }
            });
        }
        this.checkIsCmsPage();
    }

    checkIsCmsPage() {
        let isCmsPage = this.routerList[this.routerList.length - 1].link.indexOf('/content/page/') > -1;
        this.show = this.show ? !isCmsPage : this.show;
        this.routerList =   this.routerList.filter(obj => obj['name'] !== 'Reflection');
    }
}
